module.exports = "<ui-view class=\"widget-container\">\n</ui-view>\n";